<template>
  <div class="detail-feedback">
    <div v-if="eventInfo.schedule !== '-1'">
      <div class="info">
        <div class="header-title item-title">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.passengerFlowStatistics') }}</div>
        </div>
        <div class="form-item">
          <div class="label">{{ $t('form.actualTraffic') }}</div>
          <van-field v-model="feedbackInfo.actualTraffic" :disabled="eventInfoObj.isDisable" placeholder="" type="digit" :border="false" class="custom-field" />
        </div>
        <div class="form-item">
          <div class="label">{{ $t('form.openSystemCustomerTraffic') }}</div>
          <van-field v-model="feedbackInfo.openCustomerTraffic" :disabled="eventInfoObj.isDisable" placeholder="" type="digit" :border="false" class="custom-field" />
        </div>
        <div v-if="scheduleList.length === 0" class="form-item form-line-item">{{ $t('form.percentageOfOpenSystem') }}：<span class="custom-font">{{ percentageOpenSys }}</span></div>
        <div class="form-item">
          <div class="label">{{ $t('form.disposableCustomerTraffic') }}</div>
          <!-- @blur="calculateConversionRate" -->
          <van-field v-model="feedbackInfo.disposableCustomerTraffic" :disabled="eventInfoObj.isDisable" type="digit" placeholder="" :border="false" class="custom-field" />
        </div>
        <div v-if="scheduleList.length === 0" class="form-item form-line-item">{{ $t('form.percentageOfDisposable') }}：<span class="custom-font">{{ percentageDisposable }}</span></div>
      </div>
      <div class="info">
        <div class="header-title">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.salesPerformance') }}</div>
        </div>
        <!-- Event Actual Sales Section -->
        <van-collapse v-model="activeNamesOne" :border="false" class="custom-collapse">
          <van-collapse-item name="1" :border="false">
            <template #title>
              <div class="collapse-title">
                {{ $t('form.eventActualSales') }}：<span class="highlight-value">{{ productListTotal }}</span>
                <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
              </div>
            </template>
            <div class="sales-list">
              <div v-for="(item, index) in sellOutList" :key="index" class="sales-item">
                <span class="item-name">{{ item.projectName }}·{{ item.productName }}</span>
                <span class="item-value">{{ item.productCount }}</span>
              </div>
              <div class="sales-footer">
                <div class="sell-out-btn" @click="toSellOut" v-if="!eventInfoObj.isDisable && eventInfoObj.status !== 0">+ {{ $t('button.sellOut') }}</div>
                <span class="detail-link" @click="toSellOutDetail">{{ $t('button.detail') }}></span>
              </div>
            </div>
          </van-collapse-item>

          <!-- Sales Before Promotion Section -->
          <van-collapse-item name="2" :border="false">
            <template #title>
              <div class="collapse-title">
                {{ $t('form.salesBeforePromotion') }}：<span class="highlight-value">{{ saleBeforeProduct.totalInputValue }}</span>
              </div>
            </template>
            <div class="promotion-list" v-if="saleBeforeProduct.eventFeedbackProductList">
              <div v-for="(item, index) in saleBeforeProduct.eventFeedbackProductList" :key="index" class="promotion-item">
                <span class="product-name txt-ellipsis">{{ item.projectName }}·{{ item.productName }}</span>
                <div v-if="eventInfo.schedule === 1" class="stepper-custom">
                  <div class="step-btn" @click="updateSales(index, -5, 'before')">-5</div>
                  <div class="step-btn" @click="updateSales(index, -1, 'before')">-</div>
                  <van-field class="step-value" v-model="item.inputValue" type="digit" :border="false" :disabled="eventInfo.schedule === 1 && !eventInfoObj.isDisable ? false : true" />
                  <div class="step-btn" @click="updateSales(index, 1, 'before')">+</div>
                  <div class="step-btn" @click="updateSales(index, 5, 'before')">+5</div>
                </div>
                <div v-else class="input-value">{{ item.inputValue }}</div>
              </div>
              <div class="promotion-tip">
                <van-icon name="info-o" class="tip-icon" />
                <span>{{ $t('tips.messageTen') }}</span>
              </div>
            </div>
          </van-collapse-item>
          <van-collapse-item name="3" :border="false">
            <template #title>
              <div class="collapse-title">
                {{ $t('form.totalSalesInStoreDuringEvent') }}：<span class="highlight-value">{{ totalSalesStoreEvent }}</span>
              </div>
            </template>
            <div class="promotion-list">
              <div class="promotion-item">
                <span class="product-name txt-ellipsis">{{ $t('form.openSystemSales') }}</span>
                <div v-if="eventInfo.schedule === 1" class="stepper-custom">
                  <div class="step-btn" @click="handleOper('eventOpenSale', -5)">-5</div>
                  <div class="step-btn" @click="handleOper('eventOpenSale', -1)">-</div>
                  <van-field class="step-value" v-model.number="feedbackInfo.eventOpenSale" type="digit" :border="false" :disabled="eventInfo.schedule === 1 && !eventInfoObj.isDisable ? false : true" />
                  <div class="step-btn" @click="handleOper('eventOpenSale', 1)">+</div>
                  <div class="step-btn" @click="handleOper('eventOpenSale', 5)">+5</div>
                </div>
                <div v-else class="input-value">{{ feedbackInfo.eventOpenSale }}</div>
              </div>
              <div class="promotion-item">
                <span class="product-name txt-ellipsis">{{ $t('form.disposableSales') }}</span>
                <div v-if="eventInfo.schedule === 1" class="stepper-custom">
                  <div class="step-btn" @click="handleOper('eventDisposableSale', -5)">-5</div>
                  <div class="step-btn" @click="handleOper('eventDisposableSale', -1)">-</div>
                  <van-field class="step-value" v-model.number="feedbackInfo.eventDisposableSale" type="digit" :border="false" :disabled="eventInfo.schedule === 1 && !eventInfoObj.isDisable ? false : true" />
                  <div class="step-btn" @click="handleOper('eventDisposableSale', 1)">+</div>
                  <div class="step-btn" @click="handleOper('eventDisposableSale', 5)">+5</div>
                </div>
                <div v-else class="input-value">{{ feedbackInfo.eventDisposableSale }}</div>
              </div>
              <div class="promotion-tip">
                <van-icon name="info-o" class="tip-icon" />
                <span>{{ $t('tips.messageEleven') }}</span>
              </div>
            </div>
          </van-collapse-item>
          <van-collapse-item name="4" :border="false">
            <template #title>
              <div class="collapse-title">
                {{ $t('form.brandBuyers') }}
              </div>
            </template>
            <div class="promotion-list">
              <div v-for="(brandItem, brandIndex) in buyBrandList" :key="brandIndex" class="promotion-item">
                <span class="product-name txt-ellipsis">{{ brandItem.projectName }}</span>
                <div v-if="eventInfo.schedule === 1" class="stepper-custom">
                  <div class="step-btn" @click="handleOper('buyBrandList', -5, brandItem)">-5</div>
                  <div class="step-btn" @click="handleOper('buyBrandList', -1, brandItem)">-</div>
                  <van-field class="step-value" v-model.number="brandItem.inputValue" type="digit" :border="false" :disabled="eventInfo.schedule === 1 && !eventInfoObj.isDisable ? false : true" />
                  <div class="step-btn" @click="handleOper('buyBrandList', 1, brandItem)">+</div>
                  <div class="step-btn" @click="handleOper('buyBrandList', 5, brandItem)">+5</div>
                </div>
                <div v-else class="input-value">{{ brandItem.inputValue }}</div>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>

        <!-- @blur="calculateConversionRate" -->
        <!-- <div class="form-item collapse-form-item">
          <div class="label">Disposable Sales in Store During Event(Pcs)</div>
          <van-field v-model="feedbackInfo.eventDisposableSale" :disabled="eventInfoObj.isDisable" placeholder="" type="digit" :border="false" class="custom-field" />
        </div> -->
      </div>
      <div class="info">
        <div class="header-title">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.promotionEffect') }}</div>
        </div>
        <!-- Event Actual Sales Section -->
        <van-collapse v-model="activeNamesTwo" :border="false" class="custom-collapse">
          <van-collapse-item name="1" :border="false">
            <template #title>
              <div class="collapse-title">
                {{ $t('form.salesTargetForThisEventPcs') }}：<span class="highlight-value">{{ saleTargetProduct.totalInputValue }}</span>
              </div>
            </template>
            <div class="promotion-list" v-if="saleTargetProduct.eventFeedbackProductList">
              <div v-for="(item, index) in saleTargetProduct.eventFeedbackProductList" :key="index" class="promotion-item">
                <span class="product-name txt-ellipsis">{{ item.projectName }}·{{ item.productName }}</span>
                <div class="stepper-custom">
                  <div class="step-btn" @click="updateSales(index, -5, 'target')">-5</div>
                  <div class="step-btn" @click="updateSales(index, -1, 'target')">-</div>
                  <van-field class="step-value" v-model="item.inputValue" :disabled="eventInfoObj.isDisable" type="digit" :border="false" @input="calculateTotal('target')" />
                  <div class="step-btn" @click="updateSales(index, 1, 'target')">+</div>
                  <div class="step-btn" @click="updateSales(index, 5, 'target')">+5</div>
                </div>
              </div>
            </div>
          </van-collapse-item>
          <van-collapse-item name="2" :border="false">
            <template #title>
              <div class="collapse-title">
                {{ $t('form.achievementRate') }}：<span class="highlight-value">{{ saleAchievementRate.totalInputValue }}</span>
                <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
              </div>
            </template>
            <div class="sales-list" v-if="saleAchievementRate.eventFeedbackProductList">
              <div v-for="(item, index) in saleAchievementRate.eventFeedbackProductList" :key="index" class="sales-item">
                <span class="item-name">{{ item.projectName }}·{{ item.productName }}</span>
                <span class="item-value">{{ item.inputValue }}</span>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>

        <!-- <div class="form-item">
          <div class="label">
            <span>Sales Conversion Rate：</span>
            <span class="mark-label">{{ feedbackInfo.saleConversionRate }}</span>
            <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
          </div>
        </div> -->

        <div class="form-item">
          <div class="label">{{ $t('form.eventFeedback') }}</div>
          <van-field v-model="feedbackInfo.lowConversionRateRemark" :disabled="eventInfoObj.isDisable" type="textarea" show-word-limit rows="3" class="custom-field field-textarea" />
        </div>
        <div class="form-item">
          <div class="label">{{ $t('form.popupDisplayPics') }}</div>
          <van-uploader v-model="feedbackInfo.imgUrl" :disabled="eventInfoObj.isDisable" :after-read="(files, detail) => afterRead(files, detail, 'imgUrl')" />
        </div>
      </div>
      <div class="info" v-if="tagIsShow">
        <div class="header-title item-title">
          <div class="blue-bar"></div>
          <!-- 门店能力验证 -->
          <div class="title-text">{{ $t('form.storeCapacityVerification') }}</div>
        </div>
        <div class="form-item form-item-line">
          <!-- 活动前 -->
          <div class="label">{{ $t('form.beforeTheEvent') }}：</div>
          <div v-if="!['', null].includes(eventInfoObj.beforeCustomerTag)" class="tag-before-info" :class="eventInfoObj.beforeCustomerTag | formatTagClass('before')">{{ eventInfoObj.beforeCustomerTag | formatTag }}</div>
        </div>
        <div class="form-item form-after-item-line">
          <!-- 活动后 -->
          <div class="label">{{ $t('form.afterTheEvent') }}：</div>
          <!-- <van-radio-group v-model="eventInfoObj.isWaiveCustomer" :disabled="eventInfoObj.isDisable">
            <div style="display: flex; align-items: center;">
              <van-radio :name="0">Modify StoreTag</van-radio>
              <XuSelect v-model="eventInfoObj.afterCustomerTag" :disabled="eventInfoObj.isDisable || eventInfoObj.isWaiveCustomer === 1" :dataOptions="tagList" class="custom-xu-select" />
            </div>
            <van-radio :name="1">Kick out the store</van-radio>
          </van-radio-group> -->
          <XuSelect v-model="eventInfoObj.afterCustomerTag" :disabled="eventInfoObj.isDisable" :dataOptions="tagList" class="custom-xu-select" />
        </div>
      </div>
    </div>
    <div v-else class="summary-content">
      <div class="summary-title">
        <van-icon name="info-o" class="tip-icon" />
        <span>{{ $t('shared.titleSeven') }}</span>
      </div>
      <div class="info">
        <div class="header-title item-title">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.averagePassengerFlow') }}</div>
        </div>
        <div class="item-content">
          <span class="show-name">{{ $t('form.averageOfTraffic') }}：</span>
          <span class="show-value">{{ summaryData.avgTraffic }}</span>
          <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
        </div>
        <div class="item-content">
          <span class="show-name">{{ $t('form.averageOfOpenSystemCustomerTraffic') }}：</span>
          <span class="show-value">{{ summaryData.avgOpenCustomerTraffic }}</span>
          <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
        </div>
        <div class="item-content">
          <span class="show-name">{{ $t('form.percentageOfOpenSystem') }}：</span>
          <span class="show-value">{{ summaryData.percentageOpen }}</span>
          <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
        </div>
        <div class="item-content">
          <span class="show-name">{{ $t('form.averageOfDisposableCustomerTraffic') }}：</span>
          <span class="show-value">{{ summaryData.avgDisposableCustomerTraffic }}</span>
          <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
        </div>
        <div class="item-content">
          <span class="show-name">{{ $t('form.percentageOfDisposable') }}：</span>
          <span class="show-value">{{ summaryData.percentageDisposable }}</span>
          <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
        </div>
      </div>
      <div class="info">
        <div class="header-title item-title">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.salesPerformance') }}</div>
        </div>
        <div class="item-content">
          <span class="show-name">{{ $t('form.dayOfPromotion') }}：</span>
          <span class="show-value">{{ summaryData.dayPromotion }}</span>
          <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
        </div>
        <div class="item-content">
          <span class="show-name">{{ $t('form.averageSalesPcsDay') }}：</span>
          <span class="show-value">{{ summaryData.avgSale }}</span>
          <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
        </div>
        <!-- <div class="item-content">
          <span class="show-name">Average Sales Conversion Rate：</span>
          <span class="show-value">{{ summaryData.avgSaleConversionRate }}</span>
          <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
        </div> -->
      </div>
      <div class="info">
        <div class="header-title item-title">
          <div class="blue-bar"></div>
          <!-- 门店能力验证 -->
          <div class="title-text">{{ $t('form.storeCapacityVerification') }}</div>
        </div>
        <div class="item-content">
          <!-- 活动前 -->
          <span class="show-name">{{ $t('form.beforeTheEvent') }}：</span>
          <span class="tag-before-info" :class="eventInfoObj.beforeCustomerTag | formatTagClass('before')">{{ eventInfoObj.beforeCustomerTag | formatTag }}</span>
        </div>
        <div class="item-content">
          <!-- 活动后 -->
          <span class="show-name">{{ $t('form.afterTheEvent') }}：</span>
          <!-- <span v-if="eventInfoObj.isWaiveCustomer === 1" class="show-value">The store has been given up</span>v-else  -->
          <span class="show-value" :class="eventInfoObj.afterCustomerTag | formatTagClass('after')">{{ eventInfoObj.afterCustomerTag | formatAfterTag }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Popover, Toast, Dialog } from 'vant'
import { arsEventFeedbackInfoApi, arsEventFeedbackSummaryApi } from '@/api/event'
import { mapState } from 'vuex'
import { calculateAdd, calculateDivision } from '@/utils/math'
import i18n from '@/i18n'
export default {
  components: {
    [Popover.name]: Popover,
    XuSelect: () => import('@/components/XuSelect')
  },
  props: {
    currentSchedule: {
      type: Object,
      default: () => {}
    },
    eventInfoObj: {
      type: Object,
      default: () => {}
    },
    scheduleList: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    formatTag (value) {
      return value === 0 ? i18n.t('shared.filter.toBeVerified') : value === 1 ? i18n.t('shared.filter.sVIPCore') : value === 2 ? i18n.t('shared.filter.vIPCore') : value === 3 ? i18n.t('shared.filter.potential') : ''
    },
    formatTagClass (value, type) {
      return `tag${type}${value}`
    },
    formatAfterTag (value) {
      return value === 1 ? i18n.t('shared.filter.sVIPCore') : value === 2 ? i18n.t('shared.filter.vIPCore') : value === 3 ? i18n.t('shared.filter.potential') : i18n.t('shared.filter.notSet') // 未设定
    }
  },
  data () {
    return {
      activeNamesOne: ['1', '2', '3', '4'],
      activeNamesTwo: ['1', '2'],
      feedbackInfo: {
        imgUrl: []
      },
      saleBeforeProduct: {},
      saleTargetProduct: {},
      saleAchievementRate: {},
      summaryData: {},
      sellOutList: [],
      tagList: [
        { label: this.$t('shared.filter.sVIPCore'), value: 1 },
        { label: this.$t('shared.filter.vIPCore'), value: 2 },
        { label: this.$t('shared.filter.potential'), value: 3 }
      ],
      buyBrandList: []
    }
  },
  computed: {
    ...mapState('event', ['eventInfo']),
    productListTotal () {
      return this.sellOutList.reduce((acc, curr) => acc + curr.productCount, 0)
    },
    tagIsShow () {
      return !this.eventInfoObj.scheduleList || (this.eventInfoObj.scheduleList.length === 0 || this.eventInfoObj.scheduleList[this.eventInfoObj.scheduleList.length - 2].schedule === this.eventInfo.schedule)
    },
    totalSalesStoreEvent () {
      return this.calculateNum(this.feedbackInfo.eventOpenSale, this.feedbackInfo.eventDisposableSale)
    },
    // Percentage of Open System
    percentageOpenSys () {
      const result = calculateDivision(this.feedbackInfo.openCustomerTraffic, this.feedbackInfo.actualTraffic)
      return (result * 100).toFixed(2) + '%'
    },
    percentageDisposable () {
      const result = calculateDivision(this.feedbackInfo.disposableCustomerTraffic, this.feedbackInfo.actualTraffic)
      return (result * 100).toFixed(2) + '%'
    }
  },
  created () {
    // console.log('feedback-created')
  },
  activated () {
    // console.log('feedback-activated')
  },
  mounted () {
    // this.getFeedbackInfo()
    // this.getSummaryInfo()
  },
  methods: {
    handleOper (type, step, params) {
      if (type === 'buyBrandList') {
        params.inputValue = this.calculateNum(params.inputValue, step)
      } else {
        this.feedbackInfo[type] = this.calculateNum(this.feedbackInfo[type], step)
      }
    },
    getFeedbackInfo () {
      if (this.eventInfo.schedule === '-1') return
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsEventFeedbackInfoApi(this.eventInfo.eventId, this.eventInfo.schedule).then(res => {
        Toast.clear()
        const { feedback, saleBeforeProduct, saleTargetProduct, saleAchievementRate, sellOutList, buyBrandList } = res.data
        this.saleBeforeProduct = saleBeforeProduct
        this.saleTargetProduct = saleTargetProduct
        this.saleAchievementRate = saleAchievementRate
        this.sellOutList = sellOutList
        this.feedbackInfo = {
          ...feedback,
          imgUrl: this.imgFormat(feedback.imgUrl)
        }
        this.buyBrandList = buyBrandList
        // this.calculateConversionRate()
      })
    },
    imgFormat (arr) {
      let newArr = []
      if (arr && arr.length > 0) {
        newArr = arr.split(',').map(subItem => {
          return { url: subItem }
        })
        return newArr
      } else {
        return []
      }
    },
    getSummaryInfo () {
      arsEventFeedbackSummaryApi(this.eventInfo.eventId).then(res => {
        this.summaryData = res.data
      })
    },
    // calculateConversionRate () {
    //   const productListTotal = Number(this.productListTotal)
    //   const eventDisposableSale = Number(this.feedbackInfo.eventDisposableSale)
    //   if (eventDisposableSale > 0) {
    //     const rate = (productListTotal / eventDisposableSale) * 100
    //     this.feedbackInfo.saleConversionRate = rate.toFixed(2) + '%'
    //   } else {
    //     this.feedbackInfo.saleConversionRate = '0.00%'
    //   }
    // },
    toSellOut () {
      this.$router.push({
        path: '/sellOutAdd',
        query: { eventId: this.eventInfo.eventId, sellOutId: '' }
      })
    },
    toSellOutDetail () {
      this.$emit('changeTab', 1)
    },
    updateSales (index, delta, type) {
      if (this.eventInfoObj.isDisable || (type === 'before' && this.eventInfo.schedule !== 1)) return
      const targetObj = type === 'before' ? this.saleBeforeProduct : this.saleTargetProduct
      const list = targetObj.eventFeedbackProductList
      if (!list || !list[index]) return
      const item = list[index]
      let val = Number(item.inputValue) || 0
      val += delta
      if (val < 0) val = 0
      this.$set(item, 'inputValue', val)
      this.calculateTotal(type)
    },
    calculateTotal (type) {
      const targetObj = type === 'before' ? this.saleBeforeProduct : this.saleTargetProduct
      const list = targetObj.eventFeedbackProductList
      if (!list) return
      const total = list.reduce((acc, cur) => acc + (Number(cur.inputValue) || 0), 0)
      this.$set(targetObj, 'totalInputValue', total)
      if (type === 'target') {
        this.calculateAchievementRate()
      }
    },
    calculateAchievementRate () {
      // Calculate individual achievement rates
      if (this.saleTargetProduct.eventFeedbackProductList && this.saleAchievementRate.eventFeedbackProductList) {
        this.saleTargetProduct.eventFeedbackProductList.forEach(targetItem => {
          const achievementItem = this.saleAchievementRate.eventFeedbackProductList.find(
            item => item.productId === targetItem.productId
          )
          if (achievementItem) {
            const sellOutItem = this.sellOutList.find(item => item.productId === targetItem.productId)
            const sellOutCount = sellOutItem ? Number(sellOutItem.productCount) : 0
            const targetVal = Number(targetItem.inputValue) || 0

            let rate = '0.00%'
            if (targetVal > 0) {
              rate = ((sellOutCount / targetVal) * 100).toFixed(2) + '%'
            }
            this.$set(achievementItem, 'inputValue', rate)
          }
        })
      }

      // Calculate total achievement rate
      const totalSellOut = Number(this.productListTotal) || 0
      const totalTarget = Number(this.saleTargetProduct.totalInputValue) || 0
      let totalRate = '0.00%'
      if (totalTarget > 0) {
        totalRate = ((totalSellOut / totalTarget) * 100).toFixed(2) + '%'
      }
      this.$set(this.saleAchievementRate, 'totalInputValue', totalRate)
    },
    handleTips () {
      Dialog.alert({
        message: this.$t('tips.messageEight'),
        confirmButtonText: this.$t('button.gotIt'),
        confirmButtonColor: '#307bff'
      }).then(() => {
        // on close
      })
    },
    afterRead (files, detail, key) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      this.$uploadImg(files)
        .then((res) => {
          Toast.clear()
          this.$set(this.feedbackInfo[key], detail.index, {
            url: res.url
          })
        })
        .catch((err) => {
          console.log('err', err)
          Toast.clear()
          Toast(this.$t('tips.uploadFailed'))
        })
    },
    calculateNum (num1, num2) {
      return calculateAdd(num1, num2)
    }
  }
}
</script>

<style lang="less" scoped>
.detail-feedback {
  .info {
    margin-bottom: 20px;
    .header-title {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      .blue-bar {
        width: 5px;
        height: 16px;
        background-color: #307bff;
        margin-right: 5px;
      }
      .title-text {
        font-weight: bold;
        font-size: 14px;
        color: #333;
      }
    }
    .item-content {
      display: flex;
      padding: 0 10px;
      align-items: center;
      line-height: 10px;
      margin-bottom: 10px;
      font-size: 14px;
      .show-value {
        color: #307bff;
        font-weight: bold;
      }
    }
    .item-title {
      margin-bottom: 10px;
    }

    /deep/ .van-collapse-item__content {
      padding: 10px 16px;
      padding-top: 0;
    }
    /deep/.van-collapse {
      .van-collapse-item__title {
        padding: 5px 10px;
      }
    }
    .custom-collapse {
      .van-cell {
        padding: 10px 0;
        font-size: 13px;
        color: #333;
        &::after {
          display: none;
        }
      }
      .collapse-title {
        display: flex;
        align-items: center;
        .highlight-value {
          color: #307bff;
          font-weight: bold;
          margin-left: 5px;
        }
        .info-icon {
          color: #307bff;
          margin-left: 5px;
          font-size: 14px;
        }
      }
      .sales-list {
        .sales-item {
          display: flex;
          justify-content: space-between;
          padding: 10px 0;
          font-size: 12px;
          color: #333;
          border-bottom: 1px solid #e8effc;
          &:first-child {
            border-top: 2px solid #e8effc;
          }
          .item-value {
            color: #307bff;
            font-weight: bold;
          }
        }
        .sales-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
          .sell-out-btn {
            padding: 3px 3px;
            background-color: #e8effc;
            border-radius: 5px;
            font-size: 12px;
            border: 1px solid #307bff;
            color: #307bff;
          }
          .detail-link {
            color: #307bff;
            font-size: 12px;
            text-decoration: underline;
          }
        }
      }

      .promotion-list {
        .promotion-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 0;
          border-bottom: 1px solid #b9cbed;
          font-size: 12px;
          color: #333;
          &:first-child {
            border-top: 2px solid #e8effc;
          }
          .product-name {
            flex: 1;
            margin-right: 10px;
          }
          .stepper-custom {
            display: flex;
            align-items: center;
            border: 1px solid #b9cbed;
            border-radius: 4px;
            overflow: hidden;
            .step-btn {
              width: 28px;
              height: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: #fff;
              color: #333333;
              cursor: pointer;
              border-right: 1px solid #b9cbed;;
              font-size: 12px;
              &:last-child {
                border-right: none;
              }
              &:active {
                background-color: #f2f3f5;
              }
            }
            .step-value {
              width: 32px;
              height: 24px;
              padding: 0;
              background-color: #fff;
              border-right: 1px solid #b9cbed;
              border-radius: 0;
              /deep/ .van-field__control {
                text-align: center;
                height: 24px;
                line-height: 24px;
                color: #323233;
                font-size: 12px;
              }
            }
          }
          .input-value {
            color: #307bff;
            font-weight: bold;
          }
        }
        .promotion-tip {
          display: flex;
          align-items: center;
          margin-top: 10px;
          font-size: 12px;
          color: #307bff;
          .tip-icon {
            margin-right: 4px;
          }
        }
      }
    }
    .label-icon {
      width: 16px;
      height: 16px;
      margin-left: 3px;
    }
    .form-item {
      padding: 0 10px;
      margin-bottom: 13px;
      .label {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #333;
        margin-bottom: 8px;
        // 添加必填标记样式
        &.required {
          position: relative;
          padding-left: 12px; // 为星号预留空间
          &::before {
            content: '*';
            color: #ff4444;
            position: absolute;
            left: 0;
            top: 0;
            font-size: 14px;
            line-height: 1;
          }
        }
        .label-icon {
          width: 16px;
          height: 16px;
          margin-left: 3px;
        }
      }
      .mark-label {
        color: #307bff;
        font-weight: bold;
        font-size: 14px;
      }
      .custom-field {
        padding: 5px 10px;
        background: #fff;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        font-size: 12px;
        &::placeholder {
          color: #999;
        }
      }
      .field-textarea {
        min-height: 100px;
      }
      .custom-radio-field {
        padding: 0;
        font-size: 13px;
        border: none;
      }
      .phone-inputs {
        display: flex;
        align-items: center;
        .custom-field {
          flex: 1;
          text-align: center;
        }
        span {
          margin: 0 5px;
        }
      }
    }
    .form-item-line,
    .form-after-item-line {
      display: flex;
      align-items: center;
      .label {
        margin-bottom: 0;
      }
      .custom-xu-select {
        width: 136px;
      }
    }
    .collapse-form-item {
      margin-top: 10px;
    }
  }
  .summary-content {
    .summary-title {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #307bff;
      padding: 0 10px;
      margin-bottom: 10px;
      .tip-icon {
        margin-right: 4px;
      }
    }
    .show-name {
      font-size: 12px;
    }
  }
  .custom-font {
    color: #307bff;
    font-weight: bold;
  }
  /deep/.van-field--disabled {
    background-color: #ebedf0 !important;
  }
  .tag-before-info {
    padding: 3px 5px;
    text-align: center;
    font-size: 10px;
    border: 1px solid #ee541b;
    color: #ee541b;
    background-color: #eccfc4;
    margin-right: 6px;
    line-height: 13px;
  }
  .tagafter1,
  .tagafter2,
  .tagafter3 {
    padding: 3px 5px;
    text-align: center;
    font-size: 10px;
    margin-right: 6px;
    line-height: 13px;
    font-weight: 400 !important;
  }
  .tagbefore0 {
    border: 1px solid #0db00b;
    color: #0db00b;
    background-color: #abdaaa;
  }
  .tagbefore1,
  .tagafter1 {
    border: 1px solid #ee541b;
    color: #ee541b !important;
    background-color: #eccfc4;
  }
  .tagbefore2,
  .tagafter2 {
    border: 1px solid #dc851f;
    color: #dc851f !important;;
    background-color: #f0e2d1;
  }
  .tagbefore3,
  .tagafter3 {
    border: 1px solid #7f7f7f;
    color: #7f7f7f !important;;
    background-color: #dcdcdc;
  }
}

</style>
